class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// $(document).ready(function() {
  
//   function gift_item_pro() {
//     let intervalId = setInterval(function() {     
//       if($('#CartDrawer .cart--shipping-bar').length != 0){
//         if($("cart-items.is-empty, cart-drawer.is-empty, cart-drawer-items.is-empty").length == 0){
//           if ($("#CartDrawer .cart-drawer__footer .aiod_subtotal_value .money").length != 0) {
//             handle_gift_logic(intervalId);        
//           }else{
//             $("#CartDrawer.cart-drawer, body.page_cart .cart-items").addClass("loader_sideDrawer");
//           }
//         }else{
//           $("#CartDrawer.cart-drawer, body.page_cart .cart-items").removeClass("loader_sideDrawer");
//         }
//       }
//     }, 100);
//   }

//   function handle_gift_logic(intervalId) {
//     if($("#CartDrawer .cart-drawer__footer .csapps-cart-total.money").length != 0){
//       var main_price = parseFloat($("#CartDrawer .cart-drawer__footer .csapps-cart-total.money").text().replace("$", ""));
//       $("ul.discounts.list-unstyled").hide();
//       $(".cart-drawer__footer .totals.csapp_subtotal_wrapper").hide();
//       $(".cart-drawer__footer .aiod_subtotal_wrapper").show();
//       $("body.page_cart .csapp_subtotal_wrapper").hide();
//       $("body.page_cart .aiod_subtotal_wrapper").show();
//       $(".without_csapp_discount").hide();
//       $(".without_csapp_discount").siblings("div[data-csapp_price]").show();
//     }else{
//       var main_price = parseFloat($("#CartDrawer .cart-drawer__footer .aiod_subtotal_value .money").text().replace("$", ""));  
//       $("ul.discounts.list-unstyled").show();
//       $(".cart-drawer__footer .totals.csapp_subtotal_wrapper").show();
//       $(".cart-drawer__footer .aiod_subtotal_wrapper").hide();
//       $("body.page_cart .csapp_subtotal_wrapper").show();
//       $("body.page_cart .aiod_subtotal_wrapper").hide();
//       $(".without_csapp_discount").show();
//       $(".without_csapp_discount").siblings("div[data-csapp_price]").hide();
//     }
//     var price_gift = parseFloat($("#CartDrawer .shipping__progress").data("free-price"));
//     if (price_gift > main_price) {
//       // console.log("200 under");
//       $(".cart--shipping-bar-txt").html($(".cart--shipping-bar-txt").data('gift-txt'));
//       $(".cart-drawer .cart--shipping-bar-txt span").html("$" + (price_gift - main_price).toFixed(2));
//       var gift_bar_count = (main_price * 100) / price_gift;
//       $(".shipping__progress--remain").css(`width`,`${gift_bar_count}%`);
//       $(".shipping__progress_icon").css(`left`, `calc(${gift_bar_count}% - 25px)`);  
//       if ($(".cart-item.cart-items-product-free").length != 0) {
//         clearInterval(intervalId);        
//         $.ajax({
//           type: 'POST',
//           url: '/cart/change.js',
//           data: {
//             id: $('#CartDrawer .cart--shipping-bar').data('product'),
//             quantity: 0
//           },
//           dataType: 'json',
//           success: function(response) {
//             // console.log('Gift removed:', response);
//             $(".cart-item.cart-items-product-free").remove();
//             if($("body.page_cart").length != 0){
//               window.location.reload();
//             }else{
//               $('#CartDrawer').load(location.href + " #CartDrawer", function() {
//                 $("#CartDrawer.cart-drawer").removeClass("loader_sideDrawer");
//                 gift_item_pro();
//               });
//             }
//           }
//         });
//       }else{
//         $("#CartDrawer.cart-drawer, body.page_cart .cart-items").removeClass("loader_sideDrawer");
//       }
//     } else {
//       // console.log("200 up");
//       $(".cart--shipping-bar-txt").html($(".cart--shipping-bar-txt").data('cong-txt'));
//       $(".shipping__progress--remain").css(`width`,`100%`);
//       $(".shipping__progress_icon").css(`left`, `calc(100% - 25px)`);  
//       if ($(".cart-item.cart-items-product-free").length == 0) {
//         clearInterval(intervalId);
//         $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//             id: '49895880818984',
//             quantity: 1
//           },
//           dataType: 'json',
//           success: function(response) {
//             // console.log('Gift added:', response);
//             if($("body.page_cart").length != 0){
//               window.location.reload();
//             }else{
//               $('#CartDrawer').load(location.href + " #CartDrawer", function() {
//                 $("#CartDrawer.cart-drawer").removeClass("loader_sideDrawer");
//                 gift_item_pro();
//               });
//             }
//           }
//         });
//       }else{
//         $("#CartDrawer.cart-drawer, body.page_cart .cart-items").removeClass("loader_sideDrawer");
//       }
//     }
//   }
//   gift_item_pro();
  
// });


